import React, { useState } from 'react';
import '../Assests/Login.css';
import { loginUser } from '../Db_Connections/Profile_API'; // Sirf User login ke liye DB use hoga

export default function Login({ onSuccess }) {
  const [page, setPage] = useState('login'); // 'login' | 'admin'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // 1. USER LOGIN LOGIC (Database Check)
  const handleUserLogin = async () => {
    if (!email || !password) {
      alert("Please enter Email and Password");
      return;
    }

    setLoading(true);

    // Database API call
    const { data: user, error } = await loginUser(email, password);

    setLoading(false);

    if (error) {
      alert("Login Failed: " + error.message || "Invalid credentials");
      return;
    }

    // Login Successful - User ka data parent ko bhejo
    console.log("User Logged in:", user);
    onSuccess && onSuccess(user);
  };

  // 2. ADMIN LOGIN LOGIC (Updated Credentials)
  // ... baki imports

  // ADMIN LOGIN LOGIC
  const handleAdminLogin = () => {
    if (!email || !password) {
      alert("Please enter Admin Email and Password");
      return;
    }

    if (email === 'admin@example.com' && password === '1234') {
      const adminUser = {
        id: 9999, // ✅ CHANGE: String 'admin-001' hata kar Number kar diya
        role: 'Admin',
        email: email,
        first_name: 'Super',
        last_name: 'Admin',
        designation: 'System Administrator'
      };
      console.log("Admin Logged in successfully");
      onSuccess && onSuccess(adminUser);
    } else {
      alert("Invalid Admin Credentials.");
    }
  };

  // ... baki code same rahega

  // --- UI START ---

  // USER LOGIN PAGE
  if (page === 'login') {
    return (
      <div className="auth-page auth-page--user">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">Welcome Back</h1>
            <p className="auth-subtitle">Login to your account (Employees)</p>
          </div>

          <div className="auth-form">
            <div className="field">
              <label className="field-label">Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="login@example.com"
                className="field-input"
              />
            </div>

            <div className="field">
              <label className="field-label">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="field-input"
              />
            </div>

            <button
              type="button"
              onClick={handleUserLogin}
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Checking Database...' : 'Login'}
            </button>
          </div>

          <div className="auth-footer">
            <button
              type="button"
              onClick={() => { setPage('admin'); setEmail(''); setPassword(''); }}
              className="link link-indigo"
            >
              Login as Admin →
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ADMIN LOGIN PAGE
  if (page === 'admin') {
    return (
      <div className="auth-page auth-page--admin">
        <div className="auth-card">
          <div className="auth-header">
            <div className="admin-icon-wrap">
              <svg className="admin-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h1 className="auth-title">Admin Access</h1>
            <p className="auth-subtitle">Secure admin login</p>
          </div>

          <div className="auth-form">
            <div className="field">
              <label className="field-label">Admin Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                className="field-input field-input--purple"
              />
            </div>

            <div className="field">
              <label className="field-label">Admin Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="field-input field-input--purple"
              />
            </div>

            <button
              type="button"
              onClick={handleAdminLogin}
              className="btn btn-purple"
            >
              Admin Login
            </button>
          </div>

          <div className="auth-footer">
            <button
              type="button"
              onClick={() => { setPage('login'); setEmail(''); setPassword(''); }}
              className="link link-gray"
            >
              ← Back to User Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
}